if (typeof StateSelector !== "function") {
  class StateSelector extends HTMLElement {
    constructor() {
      super();

      // Create a select element (dropdown)
      const selectElement = document.createElement("select");
      this.classList.add("custom-dropdown");
      // Set the data-key attribute for the select element
      selectElement.setAttribute("data-key", "state-selector");

      const selectElements = document.querySelectorAll(
        '[data-key="state-selector"]'
      );

      // Add options to the select element
      const states = [
        "Select State",
        "AK",
        "AZ",
        "CA",
        "CO",
        "CT",
        "DC",
        "DE",
        "FL",
        "GA",
        "HI",
        "IA",
        "ID",
        "IL",
        "IN",
        "KS",
        "KY",
        "LA",
        "MD",
        "ME",
        "MI",
        "MN",
        "MO",
        "MT",
        "NC",
        "ND",
        "NE",
        "NH",
        "NJ",
        "NM",
        "NV",
        "NY",
        "OH",
        "OK",
        "OR",
        "PA",
        "RI",
        "SC",
        "TN",
        "TX",
        "VA",
        "VT",
        "WA",
        "WI",
        "WV",
        "WY"
      ];
      states.forEach((state) => {
        const option = document.createElement("option");
        option.text = state;
        selectElement.add(option);
      });

      // Add a change event listener to each select element
      selectElements.forEach((selectElement) => {
        selectElement.addEventListener("change", (event) => {
          const selectedValue = event.target.value;

          // Loop through all select elements and update their values
          selectElements.forEach((element) => {
            element.value = selectedValue;
            // Update local storage for each element if needed
            localStorage.setItem("selected-state", selectedValue);
          });
        });
      });

      // Append the select element to this custom element
      this.appendChild(selectElement);

      // Set the selected option based on local storage
      const selectedState = localStorage.getItem("selected-state");
      if (selectedState) {
        selectElement.value = selectedState;
      }
    }
  }

  if (typeof customElements.get("state-selector") === "undefined") {
    customElements.define("state-selector", StateSelector);
  }
}
